import { GetExternalAgenciesState } from './getExternalAgencies.types'

const initialState: GetExternalAgenciesState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
